import { render, staticRenderFns } from "./TabNav.vue?vue&type=template&id=b332874e&scoped=true&"
import script from "./TabNav.vue?vue&type=script&lang=js&"
export * from "./TabNav.vue?vue&type=script&lang=js&"
import style0 from "./TabNav.vue?vue&type=style&index=0&id=b332874e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b332874e",
  null
  
)

export default component.exports